import { useLocation, useNavigate } from "react-router-dom";
import { Phone } from "lucide-react";

const HIDDEN_ON = ["/admin", "/mover", "/app", "/staff", "/signoff", "/complete-job", "/booking", "/book-online", "/pay-invoice", "/invoice", "/booking-fee"];

export const MobileCallBar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  if (HIDDEN_ON.some((p) => pathname.startsWith(p))) return null;

  const goQuote = (e) => {
    e.preventDefault();
    const scroll = () => document.getElementById("quote")?.scrollIntoView({ behavior: "smooth", block: "start" });
    if (pathname !== "/") {
      navigate("/");
      setTimeout(scroll, 700);
    } else {
      scroll();
    }
  };

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 border-t border-slate-200 bg-white/95 shadow-[0_-4px_20px_rgba(15,23,42,0.12)] backdrop-blur-md sm:hidden"
      data-testid="mobile-call-bar"
    >
      <a
        href="tel:0391136005"
        className="flex items-center justify-center gap-2 py-4 text-sm font-bold uppercase tracking-wider text-blaze"
        data-testid="mobile-bar-call"
      >
        <Phone className="h-4 w-4" /> Call Now
      </a>
      <button
        type="button"
        onClick={goQuote}
        className="flex items-center justify-center gap-2 bg-blaze py-4 text-sm font-bold uppercase tracking-wider text-white"
        data-testid="mobile-bar-quote"
      >
        Get a Quote
      </button>
    </div>
  );
};
